// src/pages/Comprobacion.js
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/authContext";
import { motion } from "framer-motion";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../context/authContext";
import logo from "../assets/Logo.png";
import { FaCoins } from "react-icons/fa";
import PopupModal from "../components/PopupModal";
import { updateDoc } from "firebase/firestore";


const Comprobacion = () => {
  const {
    listaClaves,
    Estado,
    addInfoGym,
    logout,
    EstadoLogout,
    gastarTokenEnClase,
  } = useAuth();
  const navigate = useNavigate();

  const [popupType, setPopupType] = useState(null); // "tokens" | "codigo" | "ocupado"
  const [nombresGimnasios, setNombresGimnasios] = useState([]);
  const [codigoIngresado, setCodigoIngresado] = useState({});
  const [tokens, setTokens] = useState(0);

  const [showWelcome, setShowWelcome] = useState(false);

  useEffect(() => {
    const shouldShow = localStorage.getItem("showWelcomePopup");
    if (shouldShow === "true") {
      setShowWelcome(true);
      localStorage.removeItem("showWelcomePopup");
    }
  }, []);

  const frases = [
    "Pedalea en equipo, gana en motivación 💪",
    "El esfuerzo compartido se multiplica 🚴‍♂️🚴‍♀️",
    "Conéctate y supera tus límites juntos 🔥",
  ];
  const frase = frases[Math.floor(Math.random() * frases.length)];

  // Cargar donde estoy

  // 🔹 Guardar el contexto en Firestore → "comprobacion"
  // 🚫 Ya no marcamos activo = true aquí
  useEffect(() => {
    const uid = JSON.parse(localStorage.getItem("usuario"))?.[0];
    if (!uid) return;

    const userRef = doc(db, "usuarios", uid);
    updateDoc(userRef, { ultimoContexto: "/comprobacion", activo: false })
      .then(() =>
        console.log("📝 Contexto guardado en Firestore: /comprobacion + activo=false")
      )
      .catch((err) => console.error("❌ Error guardando contexto:", err));
  }, []);



  // 🔹 Cargar gimnasios en tiempo real
  useEffect(() => {
    try {

      const unsubscribe = listaClaves((gimnasios) => {
        const visibles = (gimnasios || []).filter(
          (g) =>
            g?.estado === "abierta" ||
            g?.lobbyActivo === true ||
            g?.alwaysVisibleInComprobacion === true
        );

        setNombresGimnasios(visibles);
      });


      return () => unsubscribe && unsubscribe();
    } catch (error) {
      console.error("❌ Error en listener de gimnasios:", error);
    }
  }, [listaClaves]);



  // 🔹 Cargar tokens del usuario
  useEffect(() => {
    const obtenerTokens = async () => {
      try {
        const uid = JSON.parse(localStorage.getItem("usuario"))?.[0];
        if (!uid) return;
        const userRef = doc(db, "usuarios", uid);
        const snap = await getDoc(userRef);
        if (snap.exists()) {
          setTokens(snap.data().tokens || 0);
        }
      } catch (error) {
        console.error("❌ Error al obtener tokens:", error);
      }
    };
    obtenerTokens();
  }, []);

  // 🔹 Al cerrar pestaña en comprobacion → activo = false
  useEffect(() => {
    const handleBeforeUnload = async () => {
      try {
        const uid = JSON.parse(localStorage.getItem("usuario"))?.[0];
        if (uid) {
          const userRef = doc(db, "usuarios", uid);
          await updateDoc(userRef, { activo: false });
          console.log("🚪 Usuario marcado inactivo al cerrar desde Comprobacion");
        }
      } catch (err) {
        console.error("❌ Error marcando inactivo en Comprobacion:", err);
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);


  const handleCodigoChange = (nombre, value) => {
    setCodigoIngresado((prev) => ({
      ...prev,
      [nombre]: value,
    }));
  };

  const handleVerificarCodigo = async (gimnasio) => {
    try {
      const codigoIngresadoUsuario = codigoIngresado[gimnasio.nombre] || "";
      const uid = JSON.parse(localStorage.getItem("usuario"))?.[0];
      if (!uid) return;

      const userRef = doc(db, "usuarios", uid);
      const userSnap = await getDoc(userRef);

      if (userSnap.exists()) {
        const data = userSnap.data();
        if (data.nombreGym && data.nombreGym !== gimnasio.nombre) {
          setPopupType("ocupado");
          return;
        }
      }

      if (codigoIngresadoUsuario === gimnasio.codigo) {
        // Guardar en localStorage
        localStorage.setItem("gimnasio", JSON.stringify(gimnasio.nombre));
        localStorage.setItem("claseId", JSON.stringify(gimnasio.claseId || ""));

        // Actualizar en Firestore
        await addInfoGym(gimnasio.nombre, gimnasio.claseId || "");
        //await Estado(uid);

        // Si no es gym oficial → gastar token
        if (gimnasio.isGym === false) {
          const exito = await gastarTokenEnClase(uid);
          if (!exito) {
            setPopupType("tokens");
            return;
          }
        }

        // 👇 ACTUALIZAR ultimoAcceso con la fecha actual
        const hoy = new Date().toISOString().split("T")[0];
        const userRef = doc(db, "usuarios", uid);
        await updateDoc(userRef, { ultimoAcceso: hoy });

        // 👇 Diferenciar hacia dónde redirigir
        if (gimnasio.nombre === "free") {
          navigate("/homeuser");   // Modo libre → HomeUser
        } else {
          navigate("/");           // Clase normal → Home
        }
      } else {
        setPopupType("codigo");
      }
    } catch (error) {
      console.error("❌ Error al verificar el código:", error);
    }
  };

  const handlePedalear = async () => {
    try {
      const uid = JSON.parse(localStorage.getItem("usuario"))?.[0];
      if (!uid) return;

      const userRef = doc(db, "usuarios", uid);
      const userSnap = await getDoc(userRef);

      if (userSnap.exists()) {
        const data = userSnap.data();
        if (data.nombreGym && data.nombreGym !== "") {
          setPopupType("ocupado");
          return;
        }
      }

      await addInfoGym("free", "free");
      localStorage.setItem("gimnasio", JSON.stringify("free"));
      localStorage.setItem("claseId", JSON.stringify("free"));
      //await Estado(uid);
      navigate("/homeuser");

    } catch (error) {
      console.error("❌ Error en Solo Pedalear:", error);
    }
  };

  const handleLogout = async () => {
    try {
      await addInfoGym("", "");
      localStorage.removeItem("gimnasio");
      await EstadoLogout();
      localStorage.setItem("logout", Date.now());
      await logout();
    } catch (error) {
      console.error("❌ Error en logout:", error);
    }
  };

  return (
    <div className="w-screen min-h-screen flex flex-col items-center bg-gradient-to-br from-gray-900 via-black to-gray-800 p-6">
      <div className="flex justify-center mt-6">
        <img src={logo} alt="Logo" className="mx-auto w-40" />
      </div>

      <h1 className="text-3xl font-bold text-white text-center mb-2">
        Selecciona tu equipo
      </h1>

      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="flex items-center justify-center gap-3 bg-yellow-400 text-black px-6 py-3 rounded-xl shadow-lg font-bold text-lg mb-6"
      >
        <FaCoins className="text-2xl" />
        Monedero: {tokens} tokens
      </motion.div>

      <button
        onClick={() => navigate("/comprar-tokens")}
        className="mb-8 px-6 py-3 bg-gradient-to-r from-green-500 to-emerald-600 text-white font-semibold rounded-xl shadow-md hover:opacity-90 transition"
      >
        🪙 Comprar Tokens
      </button>

      <div className="grid gap-6 w-full max-w-lg">
        {nombresGimnasios
          .slice()
          .sort((a, b) => a.prioridad - b.prioridad)
          .map((gimnasio, index) => (
            <motion.div
              key={gimnasio.id || index}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
              className="p-5 bg-white/10 backdrop-blur-lg rounded-2xl shadow-lg hover:shadow-xl transition duration-200"
            >
              <h2 className="text-xl font-semibold text-white mb-3 text-center">
                {gimnasio.nombre}
              </h2>

              <div className="flex gap-2 mb-2">
                <input
                  type="text"
                  placeholder="Introduce tu código"
                  className="flex-1 p-3 bg-black/20 border border-gray-400 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-green-500"
                  value={codigoIngresado[gimnasio.nombre] || ""}
                  onChange={(e) =>
                    handleCodigoChange(gimnasio.nombre, e.target.value.toUpperCase())
                  }
                />
                <button
                  onClick={() => handleVerificarCodigo(gimnasio)}
                  className="px-5 py-3 bg-green-500 text-white rounded-lg hover:bg-green-600 transition"
                >
                  Entrar
                </button>
              </div>

              <p className="text-sm text-gray-300 text-center leading-relaxed">
                {gimnasio.isGym ? (
                  <>
                    💪 Gimnasio oficial<br />🔥 Entrena sin gastar tokens
                  </>
                ) : (
                  <>
                    📺 Entra al directo 🔥 Solo 1 token<br />
                    🚀 ¡Súmate ya!
                  </>
                )}
              </p>
            </motion.div>
          ))}
      </div>

      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.3 }}
        className="mt-10 w-full max-w-lg text-center flex flex-col gap-4"
      >
        <button
          onClick={handlePedalear}
          className="w-full py-4 bg-gradient-to-r from-yellow-500 to-orange-600 text-white font-semibold rounded-xl shadow-md hover:from-yellow-600 hover:to-orange-700 transition"
        >
          🚴‍♂️ Entrenar en modo libre
        </button>

        <button
          onClick={() => navigate("/ranking")}
          className="bg-gradient-to-r from-blue-400 to-indigo-600 hover:from-blue-500 hover:to-indigo-700 text-white font-semibold py-3 rounded-xl shadow-lg transition"
        >
          🏆 Ranking
        </button>

        <button
          onClick={() => navigate("/historial")}
          className="bg-gradient-to-r from-purple-400 to-fuchsia-600 hover:from-purple-500 hover:to-fuchsia-700 text-white font-semibold py-3 rounded-xl shadow-lg transition col-span-2"
        >
          Ver historial
        </button>

        <button
          onClick={handleLogout}
          className="w-full py-4 bg-gradient-to-r from-gray-700 to-red-600 text-white text-lg rounded-xl shadow-md hover:from-gray-800 hover:to-red-700 transition"
        >
          ❌ Logout
        </button>
      </motion.div>

      {/* Popups usando PopupModal */}
      <PopupModal
        show={popupType === "tokens"}
        onClose={() => setPopupType(null)}
        type="error"
        title="❌ No tienes tokens disponibles"
        message="Consigue más tokens para poder unirte a una clase."
      />

      <PopupModal
        show={popupType === "codigo"}
        onClose={() => setPopupType(null)}
        type="error"
        title="❌ Código incorrecto"
        message="El código ingresado no coincide con el gimnasio."
      />

      <PopupModal
        show={popupType === "ocupado"}
        onClose={() => setPopupType(null)}
        type="error"
        title="🚫 Ya estás en otra clase"
        message="No puedes unirte a otra clase hasta salir primero de tu clase actual."
      />

      <PopupModal
        show={showWelcome}
        onClose={() => setShowWelcome(false)}
        type="success"
        title="🎉 ¡Bienvenido!"
        message="Te regalamos 3 tokens para que empieces a entrenar al máximo 🚴‍♂️🔥"
      />

      <p className="mt-8 text-gray-300 italic text-center">{frase}</p>
    </div>
  );
};

export default Comprobacion;
